<template>
    <div class="relative-position edit-speaker-profile--wrapper">
        <status-overlay :action="loadingProfileAction" content-height="500px"></status-overlay>
        <status-overlay :action="loadingOptionsAction" content-height="500px"></status-overlay>
        <v-layout
            row
            wrap
            v-if="speakerProfile && speakerProfileFromState"
            class="edit-speaker-profile">
            <v-flex
                class="edit-speaker-profile__cancel-btn"
                xs12
                text-xs-right>
                <v-btn class="primary_btn transparent" @click="BackToSpeakerProfile()">
                    <i class="fas fa-angle-left back-to"></i> {{speakerRegistrationConstants.BACK}}</v-btn>
            </v-flex>
            <v-flex
                mb-4
                class="edit-speaker-profile__section"
                v-if="isMemberSpeaker">
                <!-- ypo member profile info -->
                <v-flex xs12 tag="h3"> {{SpeakerApplicants.Section_A}}</v-flex>
                <v-form
                    v-model="basicInfo_fieldsValid"
                    ref="editProfileForm"
                    class="relative-position">
                    <v-flex v-if="displayMemberProfileLayover" class="edit-speaker-profile__unlock-member--wrapper">
                        <v-layout
                            column
                            wrap
                            class="edit-speaker-profile__unlock-member align-center">
                            <v-flex class="edit-speaker-profile__unlock-member-note" xs12>
                                {{SpeakerApplicants.NOTE}}
                            </v-flex>
                            <v-flex
                                xs12
                                pt-3
                                class="edit-speaker-profile__unlock-member-note-2">
                                <span><i class="fa fa-unlock icon-right-10"></i></span>
                                <span>{{SpeakerApplicants.UNLOCK_TO_EDIT_MEMBER_PROFILE}}</span>
                            </v-flex>
                            <v-flex xs12 pt-2>
                                <v-btn class="primary_btn" @click="unlockMemberEditSection">
                                    <i class="fas fa-pencil-alt icon-right-10"></i>
                                    {{speakerRegistrationConstants.EDIT}}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <div class="edit-speaker-profile__unlock-member-edit-below">
                            <span class="icon-right-10">{{SpeakerApplicants.EDIT_SPEAKER_PROFILE_BELOW}}</span>
                            <span><i class="fa fa-chevron-down"></i></span>
                        </div>
                    </v-flex>
                    <v-flex :class="[displayMemberProfileLayover ? 'unlock-member-wrap' : '']">
                        <span class="note" v-if="!displayMemberProfileLayover && !$vuetify.breakpoint.xs">{{SpeakerApplicants.NOTE}} </span>
                        <v-flex class="edit-member-profile">
                            <v-flex class="member">
                                <figure class="relative-position">
                                    <v-img
                                        :src="`${speakerProfile.profileImageUrl || speakerProfile.fallbackProfileImageUrl}`"
                                        contain
                                        alt="member_image"
                                        :onerror="imageErrorFallback(speakerProfile.fallbackProfileImageUrl)"></v-img>
                                    <small v-if="speakerProfile && speakerProfile.recordTypeName && !speakerProfile.recordTypeName.toLowerCase().includes('speaker')">{{speakerProfile.recordTypeName}}</small>
                                    <photo-cropper
                                        :existing-image="speakerProfile.profileImageUrl || ''"
                                        class="edit-member-profile__cropper"
                                        :upload-action-name="storeAction.uploadProfilePhoto"
                                        :post-crop-call-back="handleCroppedPhotoForMember"
                                        :cropper-title="speakerRegistrationConstants.EDIT_PROFILE_PHOTO"
                                        :upload-immediately="false">
                                    </photo-cropper>
                                </figure>
                            </v-flex>
                            <span class="note" v-if="!displayMemberProfileLayover && $vuetify.breakpoint.xs">{{SpeakerApplicants.NOTE}} </span>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.PREFERRED_NAME}}</label>
                                        <v-text-field
                                            data-qe-id="preferred-name_edit_input"
                                            :autofocus="!displayMemberProfileLayover"
                                            id="preferred-name_edit_input"
                                            autocomplete="off"
                                            solo
                                            flat
                                            v-model="speakerProfile.preferredName"></v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control primary-phone">
                                        <label>{{speakerRegistrationConstants.PHONE_NUMBER}}<em>*</em></label>
                                        <v-layout row wrap>
                                            <v-flex xs5 pr-2>
                                                <v-text-field
                                                    id="phoneCode-code_input"
                                                    data-qe-id="phoneCode-code_input"
                                                    autocomplete="off"
                                                    :rules="phoneCodeRules"
                                                    :placeholder="speakerRegistrationConstants.COUNTRY_CODE"
                                                    :maxlength="speakerRegistrationConstants.COUNTRY_CODE_MAX_LENGTH"
                                                    v-model="speakerProfile.phoneCode"
                                                    @keypress="onlyNumber"
                                                    @paste="$event.preventDefault()"
                                                    solo
                                                    flat
                                                    prepend-inner-icon="add"></v-text-field>
                                            </v-flex>
                                            <v-flex xs7>
                                                <v-text-field
                                                    id="phone-number_input"
                                                    data-qe-id="phone-number_input"
                                                    autocomplete="off"
                                                    :maxlength="speakerRegistrationConstants.PHONE_NUMBER_MAX_LENGTH"
                                                    :placeholder="speakerRegistrationConstants.PHONE_NUMBER_PLACEHOLDER"
                                                    @keypress="onlyNumber"
                                                    :rules="phoneRules"
                                                    @paste="$event.preventDefault()"
                                                    required
                                                    solo
                                                    flat
                                                    v-model="speakerProfile.phone"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.FIRST_NAME}}<em>*</em></label>
                                        <v-text-field
                                            solo
                                            autocomplete="off"
                                            flat
                                            id="first-name_input_edit"
                                            data-qe-id="first-name_input_edit"
                                            :rules="firstNameRules"
                                            v-model="speakerProfile.firstName"
                                            required></v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.PRIMARY_EMAIL}} <em>*</em></label>
                                        <v-text-field
                                            solo
                                            flat
                                            id="primary-email_input_edit"
                                            data-qe-id="primary-email_input_edit"
                                            autocomplete="off"
                                            :rules="emailRules"
                                            v-model="speakerProfile.email"
                                            required></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{EditSpeakerProfile.LAST_NAME}}<em>*</em></label>
                                        <v-text-field
                                            solo
                                            flat
                                            id="family-name_input_edit"
                                            data-qe-id="family-name_input_edit"
                                            autocomplete="off"
                                            :rules="familyNameRules"
                                            required
                                            v-model="speakerProfile.familyName"></v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex
                                    xs12
                                    sm5
                                    class="custom-fields__sm5">
                                    <v-flex class="form-control select-radio">
                                        <label>{{speakerRegistrationConstants.GENDER}} <em>*</em></label>
                                        <v-radio-group
                                            row
                                            v-model="speakerProfile.gender"
                                            :rules="genderRules"
                                            mandatory>
                                            <v-radio label="Male" value="Male"></v-radio>
                                            <v-radio label="Female" value="Female"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex class="custom-fields">
                            <v-layout row wrap>
                                <v-flex
                                    xs12
                                    sm7
                                    class="custom-fields__sm7">
                                    <v-flex class="form-control">
                                        <v-layout row wrap>
                                            <v-flex
                                                xs6
                                                sm8
                                                pr-2>
                                                <label>{{speakerRegistrationConstants.TRAVEL_FROM_CITY}}<em>*</em></label>
                                                <v-text-field
                                                    id="travel_from_city_input_edit"
                                                    data-qe-id="travel-from-ity_input_edit"
                                                    autocomplete="off"
                                                    :rules="travelFromCityRules"
                                                    required
                                                    solo
                                                    flat
                                                    v-model="speakerProfile.travelFromCity"></v-text-field>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <label>{{speakerRegistrationConstants.COUNTRY}} <em>*</em></label>
                                                <v-select
                                                    id="country_input"
                                                    data-qe-id="country_input"
                                                    :items="Object.keys(countryList)"
                                                    item-value="id"
                                                    :rules="countryRules"
                                                    required
                                                    solo
                                                    flat
                                                    v-model="speakerProfile.country">
                                                </v-select>

                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-flex>

                                <v-flex xs6>
                                    <v-flex
                                        v-if="editSpeakerInfo && !isEditBasicInfoValid"
                                        xs12
                                        class="registration-page__fees__error-text">
                                        <span>{{speakerValidationConstants.PLEASE_FILL_ALL_THE_MANDATORY_FIELDS}}</span>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <status-bar
                            v-if="savingBasicDetails"
                            :action="basicMemberProfileSaveAction"
                            :successText="SpeakerApplicants.DETAILS_SAVED_SUCCESSFULLY"></status-bar>
                        <v-flex
                            text-xs-center
                            class="action-btns"
                            v-if="!displayMemberProfileLayover && isMemberSpeaker">
                            <v-btn class="primary_btn transparent" @click="cancelBasicInfoMember()">{{speakerRegistrationConstants.CANCEL}} </v-btn>
                            <v-btn class="primary_btn" @click="saveBasicInfoMember()">{{speakerRegistrationConstants.SAVE}}</v-btn>
                        </v-flex>
                    </v-flex>

                </v-form>
                <div class="blocked-layover" v-if="savingBasicDetails"></div>
                <!-- ypo member profile info -->
            </v-flex>

            <v-flex mb-3 class="edit-speaker-profile__section">

                <v-flex xs12 tag="h3">{{speakerRegistrationConstants.EDIT_SPEAKER_PROFILE_INFORMATION}} </v-flex>
                <v-form v-model="detailed_fieldsValid" ref="editDetailedSpeakerForm">
                    <!-- speaker profile info -->
                    <v-flex xs12 class="speaker-basic-info">
                        <v-flex class="edit-member-profile" v-if="!isMemberSpeaker">
                            <v-flex class="member">
                                <figure class="relative-position">
                                    <v-img
                                        :src="`${speakerProfile.profileImageUrl || speakerProfile.fallbackProfileImageUrl}`"
                                        contain
                                        alt="member_image"
                                        :onerror="imageErrorFallback(speakerProfile.fallbackProfileImageUrl)"></v-img>
                                    <photo-cropper
                                        :existing-image="speakerProfile.profileImageUrl || ''"
                                        class="edit-member-profile__cropper"
                                        :upload-action-name="storeAction.updateSpeakerProfileImage"
                                        :post-crop-call-back="handleCroppedPhotoForMember"
                                        :cropper-title="speakerRegistrationConstants.EDIT_PROFILE_PHOTO"
                                        :upload-immediately="false">
                                    </photo-cropper>
                                </figure>
                            </v-flex>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.PREFERRED_NAME}}</label>
                                        <v-text-field
                                            id="speaker_preferred-name_input"
                                            data-qe-id="speaker_preferred-name_input"
                                            autocomplete="off"
                                            solo
                                            flat
                                            v-model="speakerProfile.preferredName"></v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control primary-phone">
                                        <label>{{speakerRegistrationConstants.PHONE_NUMBER}}<em>*</em></label>
                                        <v-layout row wrap>
                                            <v-flex
                                                xs12
                                                sm5
                                                pr-3>
                                                <v-text-field
                                                    id="speaker_phoneCode-code_input"
                                                    data-qe-id="speaker_phoneCode-code_input"
                                                    autocomplete="off"
                                                    :rules="phoneCodeRules"
                                                    :placeholder="speakerRegistrationConstants.COUNTRY_CODE"
                                                    :maxlength="speakerRegistrationConstants.COUNTRY_CODE_MAX_LENGTH"
                                                    @keypress="onlyNumber"
                                                    @paste="$event.preventDefault()"
                                                    required
                                                    solo
                                                    flat
                                                    v-model="speakerProfile.phoneCode"
                                                    prepend-inner-icon="add"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm7>
                                                <v-text-field
                                                    id="speaker_phone-number_input"
                                                    data-qe-id="speaker_phone-number_input"
                                                    autocomplete="off"
                                                    :maxlength="speakerRegistrationConstants.PHONE_NUMBER_MAX_LENGTH"
                                                    :placeholder="speakerRegistrationConstants.PHONE_NUMBER_PLACEHOLDER"
                                                    @keypress="onlyNumber"
                                                    :rules="phoneRules"
                                                    @paste="$event.preventDefault()"
                                                    required
                                                    solo
                                                    flat
                                                    v-model="speakerProfile.phone"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.FIRST_NAME}}<em>*</em></label>
                                        <v-text-field
                                            id="speaker_first-name_input"
                                            data-qe-id="speaker_first-name_input"
                                            autocomplete="off"
                                            :rules="firstNameRules"
                                            required
                                            solo
                                            flat
                                            v-model="speakerProfile.firstName"></v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.PRIMARY_EMAIL}} <em>*</em></label>
                                        <v-text-field
                                            id="speaker_primary_email_input"
                                            data-qe-id="speaker_primary_email_input"
                                            autocomplete="off"
                                            :rules="emailRules"
                                            required
                                            solo
                                            flat
                                            v-model="speakerProfile.email"></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{EditSpeakerProfile.LAST_NAME}}<em>*</em></label>
                                        <v-text-field
                                            id="family-name_input"
                                            data-qe-id="family-name_input"
                                            autocomplete="off"
                                            :rules="familyNameRules"
                                            required
                                            solo
                                            flat
                                            v-model="speakerProfile.familyName"></v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.LINKED_IN_URL}}</label>
                                        <v-text-field
                                            id="linkedi-url_input"
                                            data-qe-id="linkedin-url_input"
                                            :rules="urlRules"
                                            required
                                            solo
                                            flat
                                            v-model="speakerProfile.linkedInUrl"
                                            prepend-inner-icon="fas fa-link"></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control select-radio">
                                        <label>{{speakerRegistrationConstants.GENDER}} <em>*</em></label>
                                        <v-radio-group
                                            row
                                            v-model="speakerProfile.gender"
                                            :rules="genderRules"
                                            mandatory>
                                            <v-radio label="Male" value="Male"></v-radio>
                                            <v-radio label="Female" value="Female"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-flex>
                                <v-flex
                                    xs12
                                    sm6
                                    v-if="!isMemberSpeaker">
                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.WEBSITE_URL}}</label>
                                        <v-text-field
                                            id="website-url_input"
                                            data-qe-id="website-url_input"
                                            :rules="urlRules"
                                            required
                                            solo
                                            flat
                                            v-model="speakerProfile.webSiteUrl"
                                            prepend-inner-icon="fas fa-link"></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex
                                class="speaker-basic-info__sm7"
                                xs12
                                sm7>
                                <v-flex class="form-control" v-if="!isMemberSpeaker">
                                    <label>{{EditSpeakerProfile.EXISTING_AFFILIATIONS}}<em>*</em></label>

                                    <v-autocomplete
                                        :menu-props="{contentClass:'languages-present'}"
                                        class="associated-with-ypo"
                                        data-qe-id="ypo-association_drop-down"
                                        chips
                                        multiple
                                        solo
                                        flat
                                        :items="speakerProfile.associations"
                                        item-text="associationName"
                                        return-object
                                        @change="enableOrDisableItems()"
                                        :rules="[v => (v.length > 0 || !isSpeakerDetailsValidated) || speakerValidationConstants.ASSOCIATION]"
                                        v-model="speakerProfile.selectedAssociationsList">
                                        <template v-slot:selection="data">
                                            <v-chip
                                                :selected="data.isSelected"
                                                multiple
                                                close
                                                class="chip--select-multi"
                                                @input="removeAssociation(data.item)">
                                                {{ data.item.associationName }}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-layout
                                    row
                                    wrap
                                    v-if="!isMemberSpeaker">
                                    <v-flex
                                        xs12
                                        sm6
                                        md8
                                        pr-2
                                        class="form-control">
                                        <label>{{speakerRegistrationConstants.TRAVEL_FROM_CITY}}<em>*</em></label>
                                        <v-text-field
                                            solo
                                            flat
                                            id="speaker_travel_from_city_input_edit"
                                            data-qe-id="speaker_travel-from-ity_input_edit"
                                            autocomplete="off"
                                            :rules="travelFromCityRules"
                                            v-model="speakerProfile.travelFromCity"></v-text-field>
                                    </v-flex>
                                    <v-flex
                                        xs12
                                        sm6
                                        md4
                                        class="form-control">
                                        <label>{{speakerRegistrationConstants.COUNTRY}} <em>*</em></label>

                                        <v-select
                                            id="country_input"
                                            data-qe-id="country_input"
                                            :items="Object.keys(countryList)"
                                            item-value="id"
                                            solo
                                            flat
                                            :rules="countryRules"
                                            v-model="speakerProfile.country">
                                        </v-select>

                                    </v-flex>
                                </v-layout>
                                <v-layout
                                    row
                                    wrap
                                    v-if="!isMemberSpeaker">
                                    <v-flex xs12>
                                        <v-flex class="form-control">
                                            <label>{{speakerRegistrationConstants.TITLE}}<em>*</em></label>
                                            <v-text-field
                                                id="speaker_title_input_edit"
                                                data-qe-id="speaker_title_input_edit"
                                                autocomplete="off"
                                                solo
                                                flat
                                                :rules="titleRules"
                                                v-model="speakerProfile.title"></v-text-field>
                                        </v-flex>
                                    </v-flex>
                                </v-layout>
                                 <v-flex v-else class="form-control">
                                        <label>{{speakerRegistrationConstants.TITLE}}<em>*</em></label>
                                        <v-text-field
                                            id="title_input_edit"
                                            data-qe-id="title_input_edit"
                                            autocomplete="off"
                                            :rules="titleRules"
                                            required
                                            solo
                                            flat
                                            v-model="speakerProfile.title"></v-text-field>
                                    </v-flex>
                                <v-flex class="form-control">
                                    <label v-html="EditSpeakerProfile.FEE_RANGE_EVENT"><em>*</em></label>
                                    <v-select
                                        id="fees-range_drop_down"
                                        data-qe-id="fees-range_drop_down"
                                        :items="feeRangeList"
                                        item-text="feeRange"
                                        return-object
                                        :rules="feeRangeRules"
                                        solo
                                        flat
                                        v-model="speakerProfile.feeRange">
                                    </v-select>
                                </v-flex>

                                <v-flex class="form-control select-radio">
                                    <label>{{speakerRegistrationConstants.NEGOTIATE}} <em>*</em></label>
                                    <v-radio-group
                                        v-model="speakerProfile.reducedFee"
                                        row
                                        :rules="reducedFeeRules"
                                        mandatory>
                                        <v-radio label="Yes" value="True"></v-radio>
                                        <v-radio label="No" value="False"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-flex class="form-control select-radio">
                                    <label>{{speakerRegistrationConstants.TRP}}<em>*</em></label>

                                    <v-flex xs12 sm6>
                                        <v-flex tag="strong">
                                            <v-dialog
                                                class="custom-dailog"
                                                scrollable
                                                content-class="small"
                                                v-model="isOpenTRPDialog"
                                                persistent>
                                                <v-flex
                                                    class="form-control__more-info"
                                                    data-qe-id="more-info_trp_popup_link"
                                                    slot="activator">
                                                    <i class="fas fa-info-circle"></i>
                                                    {{speakerRegistrationConstants.MORE_INFORMATION }}
                                                </v-flex>
                                                <v-card class="registration-page__row-tooltip custom-dailog">
                                                    <v-card-title>
                                                        {{speakerRegistrationConstants.WHAT_IS_TRP}}
                                                        <i class="fas fa-times" @click="closeTRPDialog()" data-qe-id="close_dialog_btn"></i>
                                                    </v-card-title>
                                                    <v-card-text class="mr-0 pa-4 text-xs-justify font-16">
                                                        <v-flex>{{speakerRegistrationConstants.WHAT_IS_TRP_TEXT}}
                                                        </v-flex>

                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-flex class="text-xs-center pa-1 trp-actions">
                                                            <v-btn
                                                                class="primary_btn large "
                                                                @click="closeTRPDialog()"
                                                                data-qe-id="dialog_confirm_btn">
                                                                {{speakerRegistrationConstants.OK}}
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-flex>
                                    </v-flex>

                                    <v-radio-group
                                        row
                                        v-model="speakerProfile.travellingResourceProgram"
                                        mandatory>
                                        <v-radio label="Yes" :value="true"></v-radio>
                                        <v-radio label="No" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-flex>

                                <!-- Certified Forum Facilitator Form Start -->
                                <v-flex class="certified-forum" v-if="speakerProfile.isCFF">
                                    <v-layout
                                        row
                                        wrap
                                        class="certified-forum__title">
                                        <v-flex xs12 sm8><span>{{EditSpeakerProfile.CERTIFIED_FORUM_FACILITATOR}}</span></v-flex>
                                        <v-flex
                                            xs12
                                            sm4
                                            text-xs-left
                                            text-sm-right>
                                            <v-flex xs12 class="form-control">
                                                <label xs12 sm6>{{EditSpeakerProfile.SINCE}}</label>

                                                <v-flex
                                                    xs12
                                                    sm6
                                                    class="since-txt"
                                                    text-xs-right>
                                                    <v-text-field
                                                        :disabled="!speakerProfile.isAdmin"
                                                        solo
                                                        flat
                                                        type="number"
                                                        step="1"
                                                        id="speaker_since_input_edit"
                                                        data-qe-id="speaker_CFF_since_input_edit"
                                                        autocomplete="off"
                                                        :max="maxValueOfSince"
                                                        :rules="[v => (v.length === 4 && v <= maxValueOfSince) || speakerValidationConstants.INVALID_YEAR]"
                                                        v-model="speakerProfile.cffSince"></v-text-field>
                                                </v-flex>
                                            </v-flex>
                                            <v-flex xs12 class="form-control">
                                                <label xs12 sm6>Rating</label>
                                                <v-flex
                                                    xs12
                                                    sm6
                                                    class="since-txt"
                                                    text-xs-right>
                                                    <v-text-field
                                                        :disabled="!speakerProfile.isAdmin"
                                                        solo
                                                        flat
                                                        type="number"
                                                        step="0.01"
                                                        data-qe-id="CffRating_txt_box"
                                                        v-model="speakerProfile.averageCffRating"
                                                        max="5"
                                                        min="0"
                                                        :rules="[v => v.length <= 4 && (v >= 0 && v <= 5)  || speakerValidationConstants.SELECT_RATING]"></v-text-field>
                                                </v-flex>
                                            </v-flex>
                                        </v-flex>

                                    </v-layout>
                                    <v-flex class="form-control">
                                        <label>{{EditSpeakerProfile.REGION}} <em>*</em></label>
                                        <v-select
                                            :items="regionListForCFF"
                                            item-text="name"
                                            v-model="speakerProfile.cffRegion.name"
                                            @change="onRegionChange"
                                            :rules="[v => !!v || speakerValidationConstants.SELECT_REGION]"
                                            solo
                                            flat
                                            data-qe-id="CffRegion_select_box"
                                            :disabled="!speakerProfile.isAdmin">
                                        </v-select>
                                    </v-flex>
                                    <v-flex class="form-control">
                                        <label>{{EditSpeakerProfile.TAGLINE}} </label>
                                        <v-text-field
                                            v-model="speakerProfile.tagLine"
                                            solo
                                            hide-details
                                            data-qe-id="CffTagLine_txt_box"
                                            flat></v-text-field>
                                    </v-flex>
                                    <v-flex class="certified-forum__daily-rate">
                                        <v-layout
                                            row
                                            wrap
                                            class="delete-row">
                                            <v-flex xs4 sm6>
                                                <v-flex class="form-control">
                                                    <label>{{EditSpeakerProfile.FEES}} <em>*</em></label>
                                                </v-flex>
                                            </v-flex>
                                            <v-flex xs4 sm3>
                                                <v-flex class="form-control">
                                                    <label>{{EditSpeakerProfile.MINIMUM}} <em>*</em></label>
                                                </v-flex>
                                            </v-flex>
                                            <v-flex xs4 sm3>
                                                <v-flex class="form-control">
                                                    <label>{{EditSpeakerProfile.MAXIMUM}} <em>*</em></label>
                                                </v-flex>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout
                                            row
                                            wrap
                                            class="delete-row"
                                            v-for="(fee, index) in speakerProfile.cffFee"
                                            :key="index">
                                            <v-flex xs4 sm6>
                                                <v-flex class="form-control">
                                                    <v-text-field
                                                        solo
                                                        flat
                                                        hide-details
                                                        :data-qe-id="`CffFee_trainingName_${index}`"
                                                        v-model="fee.trainingName"></v-text-field>
                                                </v-flex>
                                            </v-flex>
                                            <v-flex xs4 sm3>
                                                <v-flex class="form-control">
                                                    <v-autocomplete
                                                        solo
                                                        flat
                                                        hide-details
                                                        :items="minFeesRange"
                                                        v-model="fee.minimumFee"
                                                        :data-qe-id="`CffFee_minFee_${index}`"
                                                        :rules="[v => (v >= 0 && v <= fee.maximumFee) || speakerConstants.ERROR_MESSAGES.MinFees]">
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-flex>
                                            <v-flex xs4 sm3>
                                                <v-flex class="form-control">
                                                    <v-autocomplete
                                                        solo
                                                        flat
                                                        hide-details
                                                        :items="maxFeesRange"
                                                        v-model="fee.maximumFee"
                                                        :data-qe-id="`CffFee_maxFee_${index}`"
                                                        :rules="[v => (!!v && v >= fee.minimumFee) || speakerConstants.ERROR_MESSAGES.MaxFees]">
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-flex>
                                            <span class="delete-row__delete" :data-qe-id="`CffFee_delete_btn_${index}`" @click="removeCFFFee(fee)"><i class="far fa-trash-alt"></i></span>
                                        </v-layout>
                                        <v-layout
                                            row
                                            wrap
                                            class="add-row">
                                            <v-flex xs4 sm6>
                                                <v-flex class="form-control">
                                                    <v-text-field
                                                        solo
                                                        flat
                                                        v-model="tName"
                                                        placeholder="Enter the Training name"
                                                        data-qe-id="cFF_add_training_name_txt_box"
                                                        :rules="[() => (!trainingNames.includes(tName)) || speakerConstants.ERROR_MESSAGES.Training_Name_Exists]"></v-text-field>
                                                </v-flex>
                                            </v-flex>
                                            <v-flex xs4 sm3>
                                                <v-flex class="form-control">
                                                    <v-autocomplete
                                                        solo
                                                        flat
                                                        hide-details
                                                        :items="minFeesRange"
                                                        data-qe-id="cFF_add_training_min_fee_select_box"
                                                        v-model="minFee">
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-flex>
                                            <v-flex xs4 sm3>
                                                <v-flex class="form-control">
                                                    <v-autocomplete
                                                        solo
                                                        flat
                                                        hide-details
                                                        :items="maxFeesRange"
                                                        v-model="maxFee"
                                                        data-qe-id="cFF_add_training_max_fee_select_box">
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-flex>
                                            <span class="add-row__add" data-qe-id="CFF_training_add_btn" @click="addNewTraining(tName, minFee, maxFee)"><i class="fas fa-plus-circle"></i></span>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex mt-3 class="form-control">
                                        <label>{{EditSpeakerProfile.QUALIFICATIONS}} <em>*</em></label>
                                        <ck-editor
                                            :editor-id="qualificationCKEditorId"
                                            :editor-type="ckEditorType.BASIC"
                                            data-qe-id="cFF_qualification_editor"
                                            v-model="speakerProfile.qualification"
                                            class="ck-editor__font mt-2">
                                        </ck-editor>
                                        <v-flex
                                            tag="small"
                                            v-if="isSpeakerDetailsValidated && qualificationError"
                                            class="edit-speaker-profile__all-error-text">{{speakerValidationConstants.QUALIFICATION_EMPTY_ERROR}}</v-flex>
                                    </v-flex>
                                    <v-flex mt-3 class="form-control">
                                        <label>{{EditSpeakerProfile.NUMBER_OF_FORUM_PROGRAMS}} <em>*</em></label>
                                        <v-text-field
                                            :disabled="!speakerProfile.isAdmin"
                                            min="0"
                                            max="99"
                                            type="number"
                                            solo
                                            flat
                                            data-qe-id="cFF_number_of_forum_programs"
                                            v-model="speakerProfile.numberofFourmPrograms"
                                            :rules="[ v => (v !== undefined && v !== null && v !== '' && v >= 0) || speakerConstants.ERROR_MESSAGES.Number_Of_Forum_Programs]">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex mt-4 class="form-control">
                                        <label>{{EditSpeakerProfile.RETREAT_TOPIC}} <em>*</em></label>
                                        <ck-editor
                                            :editor-id="retreatTopicCKEditorId"
                                            :editor-type="ckEditorType.BASIC"
                                            data-qe-id="cFF_retreat_editor"
                                            class="ck-editor__font"
                                            v-model="speakerProfile.retreatTopic">
                                        </ck-editor>
                                        <v-flex
                                            tag="small"
                                            v-if="isSpeakerDetailsValidated && retreatTopicError"
                                            class="edit-speaker-profile__all-error-text">{{speakerValidationConstants.RETREAT_TOPIC_ERROR}}</v-flex>
                                    </v-flex>
                                </v-flex>
                                <!-- Certified Forum Facilitator Form End -->
                                <v-flex class="form-control">
                                    <label>{{speakerRegistrationConstants.YOUR_BIOGRAPHY}} <em>*</em></label>
                                    <v-textarea
                                        id="your-biography_input"
                                        data-qe-id="your-biography_input"
                                        autocomplete="off"
                                        :rules="biographyRules"
                                        required
                                        solo
                                        flat
                                        v-model="speakerProfile.biography"></v-textarea>
                                </v-flex>
                                <v-flex class="open-caterogies">
                                    <label>{{speakerRegistrationConstants.TOPICS}} <em>*</em></label>
                                    <v-expansion-panel>
                                        <v-expansion-panel-content
                                            v-for="(topic, j) in speakerProfile.topics"
                                            :key="j"
                                            :data-qe-id="`topics-epxansion_expand_btn_${j}`">
                                            <div slot="header">
                                                <v-layout
                                                    row
                                                    wrap
                                                    :class="[topicsError ? 'registration-page__my-topics__header registration-page__my-topics__header__error' : 'registration-page__my-topics__header']">
                                                    <v-flex><i class="far fa-plus-square icon-right-10"></i>{{topic.topicName}}</v-flex>
                                                </v-layout>
                                            </div>
                                            <v-flex mb-3 v-if="topic.selectedTopics.length > 0">
                                                <v-chip
                                                    v-for="(topics, index) in topic.selectedTopics"
                                                    :key="index"
                                                    :data-qe-id="`selected-topics_index_${index}`"
                                                    close
                                                    @input="removeTopic(index, topic.selectedTopics)">
                                                    {{ topics.topicName }}
                                                </v-chip>
                                                <span class="clear-all" @click="clearTopic(j)">
                                                    <i data-qe-id="`selected-topics_index_clear_all_topics`" class="material-icons clear-all__close">close</i> {{ speakerRegistrationConstants.CLEAR_ALL_THIS_CATEGORY }}
                                                </span>
                                            </v-flex>
                                            <SpeakerTopics :topic="topic"></SpeakerTopics>
                                        </v-expansion-panel-content>

                                    </v-expansion-panel>

                                    <v-flex
                                        tag="small"
                                        v-if="topicsError"
                                        class="edit-speaker-profile__all-error-text">{{speakerValidationConstants.TOPIC_SELCTION}}</v-flex>
                                </v-flex>
                                <v-flex class="form-control">
                                    <label>{{EditSpeakerProfile.LANGUAGES}} <em>*</em></label>
                                    <v-autocomplete
                                        :menu-props="{contentClass:'languages-present'}"
                                        id="languages-present-in_drop_down"
                                        data-qe-id="languages-present-in_drop_down"
                                        chips
                                        solo
                                        flat
                                        multiple
                                        :items="speakerProfile.languages"
                                        item-text="languageName"
                                        return-object
                                        :rules="languagesRules"
                                        v-model="speakerProfile.selectedLanguageList">
                                        <template v-slot:selection="data">
                                            <v-chip
                                                :selected="data.isSelected"
                                                close
                                                class="chip--select-multi"
                                                @input="removeLanguage(data.item)">
                                                {{ data.item.languageName }}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex class="form-control select-radio">
                                    <label>{{speakerRegistrationConstants.RESOURCE_SERVING}} <em>*</em></label>

                                    <v-radio-group
                                        row
                                        v-model="speakerProfile.servingResource"
                                        mandatory>
                                        <v-radio label="Yes" :value=true></v-radio>
                                        <v-radio label="No" :value=false></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-flex class="form-control ypo-referrals">
                                    <label>{{EditSpeakerProfile.YPO_REFERRAlS}}</label>
                                    <v-flex v-for="(referral,index) in speakerProfile.selectedReferrals" :key="index">
                                        <v-text-field
                                            v-model="referral.referralName"
                                            solo
                                            flat
                                            append-icon="fas fa-times-circle"
                                            @click:append="removeReferralLine(referral)"></v-text-field>
                                    </v-flex>
                                    <v-text-field
                                        id="referrals_input"
                                        data-qe-id="referrals_input"
                                        solo
                                        flat
                                        v-model="referrals"
                                        required>
                                        <i slot="append" :class="['fas fa-plus-circle form-control__add-icon', !referrals || (referrals && referrals.trim() === '') ? 'is-disabled':'']" @click="addRefferal" small data_qe_id="add-referrals_btn"><small>ADD MORE</small></i>
                                    </v-text-field>
                                </v-flex>

                            </v-flex>
                            <v-flex
                                xs12
                                sm5
                                class="speaker-presentations speaker-basic-info__sm5">
                                <h4 class="speaker-presentations__title"> {{EditSpeakerProfile.PRESENTATIONS}} </h4>
                                <v-flex class="speaker-presentations__update video-uploader">
                                    <drag-and-drop-video
                                        :display-new-video-upload-warning="speakerProfile.presentationUrl === null || speakerProfile.presentationUrl === '' ? false : true"
                                        v-model="newPresentationVideo"
                                        :upload-video-label="speakerProfile.presentationUrl === null || speakerProfile.presentationUrl === '' ? speakerRegistrationConstants.UPLOAD_A_VIDEO_PRESENTATION : speakerRegistrationConstants.UPLOAD_ANOTHER_VIDEO"
                                        :videoTypesSupported="speakerRegistrationConstants.VIDEO_TYPES_SUPPORTED">
                                    </drag-and-drop-video>
                                </v-flex>
                                <v-layout
                                    row
                                    wrap
                                    class="speaker-presentations__video">
                                    <v-flex xs12 v-if="speakerProfile.presentationUrl">
                                        <video preload="metadata" class="mt-2" width="100%" height="200" controls :src="speakerProfile.presentationUrl">
                                        </video>
                                    </v-flex>

                                </v-layout>
                                <v-flex class="speaker-presentations__engagements">

                                    <v-flex class="form-control">
                                        <label>{{speakerRegistrationConstants.OTHER_ENGAGEMENTS_LINKS}}</label>
                                        <v-flex v-for="(tedTalkLinks,index) in speakerProfile.selectedOtherLinks" :key="index">
                                            <v-text-field
                                                class="form-fields__add-field"
                                                v-model="tedTalkLinks.engagementLink"
                                                :rules="urlRules"
                                                solo
                                                flat
                                                append-icon="fas fa-times-circle form-fields__add-field__icon"
                                                @click:append="removeTedTalkLink(tedTalkLinks)"></v-text-field>
                                        </v-flex>

                                        <v-text-field
                                            class="form-control"
                                            id="others-engagements-links_input"
                                            data-qe-id="others-engagements-links_input"
                                            solo
                                            flat
                                            v-model="tedTalkLinks"
                                            :rules="urlRules"
                                            prepend-inner-icon="link"
                                            required>
                                            <i slot="append" :class="['fas fa-plus-circle form-control__add-icon', !tedTalkLinks || (tedTalkLinks && tedTalkLinks.trim() === '')  === '' ?'is-disabled':'']" @click="addTedTalkLinks" small data_qe_id="add-previous_btn"><small>ADD MORE</small></i>
                                        </v-text-field>

                                    </v-flex>
                                    <v-flex class="form-control" v-if="isMemberSpeaker">
                                        <label>{{speakerRegistrationConstants.WEBSITE_URL}}</label>
                                        <v-text-field
                                            id="website-url_input_edit"
                                            data-qe-id="website-url_input_edit"
                                            :rules="urlRules"
                                            required
                                            solo
                                            flat
                                            v-model="speakerProfile.webSiteUrl"
                                            prepend-inner-icon="fas fa-link"></v-text-field>
                                    </v-flex>
                                    <v-flex class="form-control" v-if="isMemberSpeaker">
                                        <label>{{speakerRegistrationConstants.LINKED_IN_URL}}</label>
                                        <v-text-field
                                            id="linkedi-url_input"
                                            data-qe-id="linkedin-url_input"
                                            :rules="urlRules"
                                            required
                                            solo
                                            flat
                                            v-model="speakerProfile.linkedInUrl"
                                            prepend-inner-icon="fas fa-link"></v-text-field>
                                    </v-flex>
                                   
                                    <v-flex class="form-control">
                                        <v-flex tag="strong">{{speakerRegistrationConstants.PREVIOUS_YPO_SPEAKER}}*</v-flex>
                                        <v-radio-group
                                            row
                                            v-model="speakerProfile.previuoslySpokenAtYpoEvent"
                                            :rules="previuoslySpokenAtYpoEventRules"
                                            mandatory>
                                            <v-layout row mt-2>
                                                <v-radio
                                                    class="mb-0"
                                                    data-qe-id="previous_ypo_speaker_input_yes"
                                                    label="YES"
                                                    :value=true></v-radio>
                                                <v-radio
                                                    data-qe-id="previous_ypo_speaker_input_no"
                                                    label="NO"
                                                    :value=false></v-radio>
                                            </v-layout>
                                        </v-radio-group>

                                        <v-flex v-if="speakerProfile.previuoslySpokenAtYpoEvent">

                                            <label>{{speakerRegistrationConstants.PREVIOUS_SPEAKER_EVENTS}}*</label>
                                            <v-flex class="registration-page__row-label__subhead">{{speakerRegistrationConstants.YPO_CHAPTER}}</v-flex>
                                            <v-flex v-for="(event, index) in speakerProfile.selectedSpeakerEventsYouHaveSpokes" :key="index">
                                                <v-text-field
                                                    class="form-fields__add-field"
                                                    v-model="event.eventsYouHaveSpoke"
                                                    solo
                                                    flat
                                                    append-icon="fas fa-times-circle form-fields__add-field__icon"
                                                    @click:append="removeSpokenEventLine(event)"></v-text-field>
                                            </v-flex>
                                            <v-text-field
                                                id="previous-speaker-event_input"
                                                data-qe-id="previous-speaker-event_input"
                                                solo
                                                flat
                                                hide-details
                                                v-model="previousSpeakerEvents"
                                                required>
                                                <i slot="append" :class="['fas fa-plus-circle form-control__add-icon', !previousSpeakerEvents || (previousSpeakerEvents && previousSpeakerEvents.trim() === '') === '' ? 'is-disabled':'']" @click="addSpeakerEventLine" small data_qe_id="add-previous_btn"><small>ADD MORE</small></i>
                                            </v-text-field>
                                            <v-flex
                                                tag="small"
                                                v-if="eventsYouHaveSpokeError"
                                                class="edit-speaker-profile__all-error-text">{{speakerValidationConstants.PREVIOUS_EVENT_ERROR}}
                                            </v-flex>
                                        </v-flex>
                                    </v-flex>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <!-- speaker profile info -->

                </v-form>

                <status-bar :action="presentationUploadAction"></status-bar>
                <status-bar
                    v-if="savingSpeakerDetails"
                    :action="editedProfileSaveAction"
                    :successText="SpeakerApplicants.DETAILS_SAVED_SUCCESSFULLY"></status-bar>
                <v-flex
                    pa-3
                    v-if="isSpeakerDetailsValidated && !isEditDetailedInfoValid"
                    xs12
                    text-xs-right
                    class="edit-speaker-profile__all-error-text">
                    <span>{{speakerValidationConstants.PLEASE_FILL_ALL_THE_MANDATORY_FIELDS}}</span>
                </v-flex>
                <v-flex
                    text-xs-center
                    pb-3
                    class="action-btns">
                    <v-btn class="primary_btn transparent" @click="cancelSpeakerProfileEdit">{{speakerRegistrationConstants.CANCEL}} </v-btn>
                    <v-btn class="primary_btn" @click="saveSpeakerProfile">{{speakerRegistrationConstants.SAVE}}</v-btn>
                </v-flex>
                <div class="blocked-layover" v-if="savingSpeakerDetails"></div>
            </v-flex>

        </v-layout>
    </div>
</template>

<script>
    import { getCurrentYear } from "../../common/utils/dateTime";
    import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "@/store/storeActions.constant";
    import { storeMutation } from "@/store/storeMutations.constant";
    import StatusOverlay from "../StatusOverlay/StatusOverlay.vue";
    import { imageErrorFallback, onlyNumber, getRandomId } from "../../common/utils/utils";
    import ckEditor from "../CkEditor/CkEditor";
    import { ckEditorType } from "../../plugins/CkEditor/ckEditorTypes.config";
    import SpeakerTopics from "../Speakers/SpeakerTopics";
    import {
        SpeakerApplicants,
        speakerRegistrationConstants,
        EditSpeakerProfile,
        speakerValidationConstants,
        SpeakerValidationRules,
    } from "../Speakers/speakerConstant";
    import DragAndDropVideo from "../Speakers/DragAndDropVideo";
    import PhotoCropper from "../PhotoCropper/PhotoCropper";
    import { uuid } from 'vue-uuid';
    import { cancelSpeakerProfileBasicDetails, cancelSpeakerProfileDetails } from "../../store/classes/speaker/speakerProfile";
    import StatusBar from "../StatusBar/StatusBar";
    import { speakerConstants, generateRange } from "./ResourceConstants";

    export default {
        name: "EditSpeakerProfile",
        components: {
            StatusBar,
            PhotoCropper,
            DragAndDropVideo,
            StatusOverlay,
            SpeakerTopics,
            ckEditor,
        },

        data: () => ({
            ...SpeakerValidationRules,
            isSpeakerDetailsValidated: false,
            savingBasicDetails: false,
            savingSpeakerDetails: false,
            speakerProfile: null,
            referrals: '',
            tedTalkLinks: '',
            previousSpeakerEvents: '',
            newProfileImage: [],
            newPresentationVideo: [],
            displayMemberProfileLayover: false,
            SpeakerApplicants,
            speakerRegistrationConstants,
            EditSpeakerProfile,
            speakerValidationConstants,
            storeAction,
            ckEditorType,
            profileImage: {},
            onlyNumber,
            editSpeakerInfo: false,
            basicInfo_fieldsValid: false,
            detailed_fieldsValid: false,
            uuid: uuid.v4(),
            isOpenTRPDialog: false,
            CFFRating: 0.0,
            qualificationCKEditorId: getRandomId(),
            retreatTopicCKEditorId: getRandomId(),
            maxValueOfSince: getCurrentYear(),
            speakerConstants,
            yearRange: generateRange(1980, getCurrentYear(), 1),
            tName: '',
            maxFee: '',
            minFee: '',
            feeError: false,
        }),
        created() {
            this.getRegionListForCFF();
            this.getFeesRange();
            let speakerType = '';
            let speakerStatus = '';

            if (this.isSpeakerView) {
                speakerType = 'member';
                speakerStatus = 'A';
            } else {
                speakerType = sessionStorage.getItem(SpeakerApplicants.SPEAKER_TYPE) === null ? 'member' : sessionStorage.getItem(SpeakerApplicants.SPEAKER_TYPE);
                speakerStatus = sessionStorage.getItem(this.SpeakerApplicants.SPEAKER_STATUS) === null ? 'A' : sessionStorage.getItem(this.SpeakerApplicants.SPEAKER_STATUS);
            }
            this.editProfile = {
                Id: this.$route.query.id,
                Type: speakerType,
                ApprovalStatus: speakerStatus,
            };

            //getting all the basic options for speaker if not there
            this.getBasicOptionsForSpeaker()
                .then(() => {
                    let newPromise = Promise.resolve();
                    if (this.speakerProfileFromState && this.speakerProfileFromState.personId) {
                        this.speakerProfile = {
                            ...this.speakerProfileFromState,
                        };
                    } else {
                        newPromise = this.getSpeakerProfile(this.editProfile);
                    }

                    return newPromise;
                })
                .then(() => {
                    this.reformSpeakerProfileDetails();
                    this.displayMemberProfileLayover = this.isMemberSpeaker;
                    this.enableOrDisableItems();
                });
        },
        methods: {
            generateRange,
            ...mapActions({
                getSpeakerProfile: `speaker/${storeAction.getSpeakerProfile}`,
                saveEditedSpeakerProfile: `speaker/${storeAction.saveEditedSpeakerProfile}`,
                getLanguagesList: `speaker/${storeAction.getLanguagesList}`,
                getCountryList: `speaker/${storeAction.getCountryList}`,
                getFeeRangeList: `speaker/${storeAction.getFeeRangeList}`,
                getBasicOptionsForSpeaker: `speaker/${storeAction.getBasicOptionsForSpeaker}`,
                uploadSpeakerRegistrationPresentation: `speaker/${storeAction.uploadSpeakerRegistrationPresentation}`,
                updateSpeakerProfileImage: `speaker/${storeAction.updateSpeakerProfileImage}`,
                getFeesRange: `speaker/${storeAction.getFeesRange}`,
                uploadProfilePhoto: `speaker/${storeAction.uploadProfilePhoto}`,
                getRegionListForCFF: `speaker/${storeAction.getRegionListForCFF}`,
            }),
            ...mapMutations({
                setProfileInfoUpdatedFromSpeaker: `myAccount/${storeMutation.setProfileInfoUpdatedFromSpeaker}`,
                updateSpeakerEditDetailsToPendingOrApprovalList: `speaker/${storeMutation.updateSpeakerEditDetailsToPendingOrApprovalList}`,
            }),
            imageErrorFallback,
            cancelSpeakerProfileBasicDetails,
            cancelSpeakerProfileDetails,
            closeTRPDialog() {
                this.isOpenTRPDialog = false;
            },
            getCurrentYear,
            BackToSpeakerProfile() {
                this.$router.push({
                    path: '/speakerPage/speakerProfile',
                    query: {
                        id: this.$route.query.id,
                    },
                });
            },
            generateGUID() {
                return uuid.v4();
            },
            reSetSelectedTopics(topicList) {
                topicList.forEach((parentTopic) => {
                    parentTopic.selectedTopics = parentTopic.childTopics.filter(topic => topic.isSelected);
                });
                return topicList;
            },
            saveBasicInfoMember() {
                if (this.isEditBasicInfoValid) {
                    const saveObject = {
                        ...this.speakerProfile,
                        saveMemberBasicDetails: true,
                    };

                    this.savingBasicDetails = true;
                    this.uploadingNewProfileImage().then(() => {
                        this.saveEditedSpeakerProfile(saveObject)
                            .then(() => {
                                if (this.currentUserId === this.$route.query.id) {
                                    this.setProfileInfoUpdatedFromSpeaker({ speakerProfile: this.speakerProfileFromState, isSpeakerView: this.isSpeakerView });
                                }
                                this.updateSpeakerEditDetailsToPendingOrApprovalList(this.speakerProfileFromState);
                            })
                            .catch(() => { console.log('error in saving'); })
                            .finally(() => {
                                setTimeout(() => {
                                    this.savingBasicDetails = false;
                                }, this.SpeakerApplicants.SUCCESS_DURATION);
                            });
                    });
                } else {
                    this.editSpeakerInfo = true;
                    this.$refs.editProfileForm.validate();
                }
            },
            getRandomId,
            uploadingNewPresentationVideo() {
                let uploadingNewVideo = Promise.resolve();
                if (this.newPresentationVideo && this.newPresentationVideo.length) {
                    const fileExtension = this.newPresentationVideo[0].name.split('.')[this.newPresentationVideo[0].name.split('.').length - 1];
                    const presentationUrl = `${this.speakerProfile.firstName}_${this.getRandomId()}.${fileExtension}`;
                    uploadingNewVideo = this.uploadSpeakerRegistrationPresentation({
                        file: this.newPresentationVideo[0],
                        fileName: presentationUrl,
                    });
                }
                return uploadingNewVideo;
            },

            uploadingNewProfileImage() {
                let uploadingNewImage = Promise.resolve();
                if (this.newProfileImage && this.newProfileImage.length) {
                    if (this.isMemberSpeaker) {
                        uploadingNewImage = this.uploadProfilePhoto(this.newProfileImage[0]);
                    } else {
                        uploadingNewImage = this.updateSpeakerProfileImage(this.newProfileImage[0]);
                    }
                }
                return uploadingNewImage;
            },
            saveInCompletedFields() {
                this.addRefferal();
                this.addTedTalkLinks();
                this.addSpeakerEventLine();
            },
            saveSpeakerProfile() {
                this.saveInCompletedFields();
                if (this.isEditDetailedInfoValid) {
                    const saveObject = {
                        ...this.speakerProfile,
                        saveMemberBasicDetails: this.isMemberSpeaker && !this.displayMemberProfileLayover ? false : null,
                        languages: this.setSelectedLanguagesForSave(this.speakerProfile.languages, this.speakerProfile.selectedLanguageList),
                        speakerEventsYouHaveSpokes: this.speakerProfile.selectedSpeakerEventsYouHaveSpokes,
                        otherLinks: this.speakerProfile.selectedOtherLinks,
                        referrals: this.speakerProfile.selectedReferrals,
                        topics: this.setSelectedTopicsForSave(),
                        title: this.speakerProfile.title,
                        associations: this.setSelectedAssociationsForSave(this.speakerProfile.associations, this.speakerProfile.selectedAssociationsList),
                    };
                    this.savingSpeakerDetails = true;
                    Promise.all([this.uploadingNewProfileImage(), this.uploadingNewPresentationVideo()]).then((resArray) => {
                        if (!this.isMemberSpeaker && resArray[0]) {
                            saveObject.profileImageUrl = resArray[0].data;
                        }
                        if (resArray[1]) {
                            saveObject.presentationUrl = resArray[1].fileName;
                            this.newPresentationVideo = [];
                        }
                        this.saveEditedSpeakerProfile(saveObject)
                            .then((response) => {
                                this.reformSpeakerProfileDetails(false);
                                if (this.currentUserId === this.$route.query.id) {
                                    this.setProfileInfoUpdatedFromSpeaker({ speakerProfile: this.speakerProfileFromState, isSpeakerView: this.isSpeakerView });
                                }
                                this.updateSpeakerEditDetailsToPendingOrApprovalList(this.speakerProfileFromState);
                            })
                            .catch(() => { console.log('error in saving'); })
                            .finally(() => {
                                this.isSpeakerDetailsValidated = false;
                                setTimeout(() => {
                                    this.savingSpeakerDetails = false;
                                }, this.SpeakerApplicants.SUCCESS_DURATION);
                            });
                    });
                } else {
                    this.isSpeakerDetailsValidated = true;
                    this.$refs.editDetailedSpeakerForm.validate();
                }
            },
            setSelectedLanguagesForSave(langList, selectedLangs) {
                langList.forEach((lang) => {
                    lang.isSelected = selectedLangs.some(item => item.id === lang.id);
                });
                return langList;
            },
            setSelectedAssociationsForSave(assList, selectedAss) {
                assList.forEach((association) => {
                    association.isSelected = selectedAss.some(item => item.id === association.id);
                });
                return assList;
            },
            setSelectedTopicsForSave() {
                this.speakerProfile.topics.forEach((parentTopic) => {
                    parentTopic.childTopics.forEach((topic) => {
                        topic.isSelected = parentTopic.selectedTopics.some(item => item.id === topic.id);
                    });
                });
                return this.speakerProfile.topics;
            },
            handleCroppedPhotoForMember(newPhotoData) {
                const fileName = `${this.speakerProfile.firstName}_${this.getRandomId()}.png`;
                this.newProfileImage = [];
                this.newProfileImage.push({
                    personId: this.speakerProfile.personId,
                    imageName: fileName,
                    imageData: newPhotoData.imageData,
                });
                const fileUrl = URL.createObjectURL(newPhotoData.imageFile);
                this.speakerProfile = {
                    ...this.speakerProfile,
                    profileImageUrl: `${fileUrl}`,
                };
            },

            cancelBasicInfoMember() {
                this.editSpeakerInfo = false;
                this.cancelSpeakerProfileBasicDetails(this.speakerProfile, this.speakerProfileFromState);
                this.newProfileImage = [];
            },
            unlockMemberEditSection() {
                this.displayMemberProfileLayover = false;
            },
            cancelSpeakerProfileEdit() {
                if (!this.isMemberSpeaker) {
                    this.cancelBasicInfoMember();
                }
                this.cancelSpeakerProfileDetails(this.speakerProfile, this.speakerProfileFromState);
                this.speakerProfile = {
                    ...this.speakerProfile,
                    selectedSpeakerEventsYouHaveSpokes: this.speakerProfileFromState.speakerEventsYouHaveSpokes ? this.speakerProfile.speakerEventsYouHaveSpokes.map(f => ({ id: f.id, eventsYouHaveSpoke: f.eventsYouHaveSpoke })) : [],
                    selectedLanguageList: this.speakerProfileFromState.languages.filter(lan => lan.isSelected),
                    selectedOtherLinks: this.speakerProfileFromState.otherLinks.map(f => ({ id: f.id, engagementLink: f.engagementLink })),
                    selectedReferrals: this.speakerProfileFromState.referrals.map(f => ({ id: f.id, referralName: f.referralName })),
                    selectedAssociationsList: this.speakerProfileFromState.associations.filter(associate => associate.isSelected),
                    topics: this.reSetSelectedTopics(this.speakerProfileFromState.topics),
                };
                this.newPresentationVideo = [];
                this.referrals = '';
                this.tedTalkLinks = '';
                this.previousSpeakerEvents = '';
            },
            reformSpeakerProfileDetails(reformAllFields = true) {
                if (reformAllFields || !this.isMemberSpeaker) {
                    this.speakerProfile = {
                        ...this.speakerProfileFromState,
                    };
                    this.newProfileImage = [];
                } else {
                    this.speakerProfile = {
                        ...this.speakerProfile,
                        feeRange: this.speakerProfileFromState.feeRange,
                        reducedFee: this.speakerProfileFromState.reducedFee,
                        travellingResourceProgram: this.speakerProfileFromState.travellingResourceProgram,
                        biography: this.speakerProfileFromState.biography,
                        servingResource: this.speakerProfileFromState.servingResource,
                        webSiteUrl: this.speakerProfileFromState.webSiteUrl,
                        previuoslySpokenAtYpoEvent: this.speakerProfileFromState.previuoslySpokenAtYpoEvent,
                        presentationUrl: this.speakerProfileFromState.presentationUrl,
                    };
                }
                this.speakerProfile = {
                    ...this.speakerProfile,
                        cffRegion: this.speakerProfileFromState.cffRegion ? { id: this.speakerProfileFromState.cffRegion.id, name: this.speakerProfileFromState.cffRegion.name } : {},
                        cffFee: this.speakerProfileFromState.cffFee ? this.speakerProfileFromState.cffFee.map(f => ({
                            id: f.id,
                            trainingName: f.trainingName,
                            maximumFee: f.maximumFee,
                            minimumFee: f.minimumFee,
                        })) : [],
                        selectedSpeakerEventsYouHaveSpokes: this.speakerProfileFromState.speakerEventsYouHaveSpokes ? this.speakerProfileFromState.speakerEventsYouHaveSpokes.map(f => ({ id: f.id, eventsYouHaveSpoke: f.eventsYouHaveSpoke })) : [],
                        selectedLanguageList: this.speakerProfileFromState.languages.filter(lan => lan.isSelected),
                        selectedOtherLinks: this.speakerProfileFromState.otherLinks.map(f => ({ id: f.id, engagementLink: f.engagementLink })),
                        selectedReferrals: this.speakerProfileFromState.referrals.map(f => ({ id: f.id, referralName: f.referralName })),
                        selectedAssociationsList: this.speakerProfileFromState.associations.filter(associate => associate.isSelected),
                };
            },
            removeReferralLine(item) {
                if (this.speakerProfile && this.speakerProfile.selectedReferrals && this.speakerProfile.selectedReferrals.length) {
                    this.speakerProfile.selectedReferrals =
                        this.speakerProfile.selectedReferrals.filter(it => it.referralName !== item.referralName);
                }
            },

            removeAssociation(item) {
                if (this.speakerProfile && this.speakerProfile.selectedAssociationsList && this.speakerProfile.selectedAssociationsList.length) {
                    this.speakerProfile.selectedAssociationsList =
                        this.speakerProfile.selectedAssociationsList.filter(it => it.id !== item.id);
                    this.enableOrDisableItems();
                }
            },
            removeSpokenEventLine(item) {
                if (this.speakerProfile && this.speakerProfile.selectedSpeakerEventsYouHaveSpokes && this.speakerProfile.selectedSpeakerEventsYouHaveSpokes.length) {
                    this.speakerProfile.selectedSpeakerEventsYouHaveSpokes =
                        this.speakerProfile.selectedSpeakerEventsYouHaveSpokes.filter(it => it.eventsYouHaveSpoke !== item.eventsYouHaveSpoke);
                }
            },
            removeTedTalkLink(item) {
                if (this.speakerProfile && this.speakerProfile.selectedOtherLinks && this.speakerProfile.selectedOtherLinks.length) {
                    this.speakerProfile.selectedOtherLinks =
                        this.speakerProfile.selectedOtherLinks.filter(it => it.engagementLink !== item.engagementLink);
                }
            },
            removeLanguage(lang) {
                if (this.speakerProfile && this.speakerProfile.selectedLanguageList && this.speakerProfile.selectedLanguageList.length) {
                    this.speakerProfile.selectedLanguageList =
                        this.speakerProfile.selectedLanguageList.filter(it => it.id !== lang.id);
                }
            },
            addTedTalkLinks() {
                this.tedTalkLinks = this.tedTalkLinks.trim();
                if (this.tedTalkLinks) {
                    if (!this.urlRules.some(rule => rule(this.tedTalkLinks) !== true)) {
                        this.speakerProfile.selectedOtherLinks.push({
                            id: this.generateGUID(),
                            engagementLink: this.tedTalkLinks,
                        });
                        this.tedTalkLinks = '';
                    }
                }
            },
            addRefferal() {
                if (this.referrals.trim() !== '') {
                    this.speakerProfile.selectedReferrals.push({
                        id: this.generateGUID(),
                        referralName: this.referrals,
                    });
                    this.referrals = '';
                }
            },
            addSpeakerEventLine() {
                if (this.previousSpeakerEvents.trim() !== '') {
                    this.speakerProfile.selectedSpeakerEventsYouHaveSpokes.push({
                        id: this.generateGUID(),
                        eventsYouHaveSpoke: this.previousSpeakerEvents,
                    });
                    this.previousSpeakerEvents = '';
                }
            },

            removeTopic(index, list) {
                list.splice(index, 1);
            },

            clearTopic(topicListIndex) {
                this.speakerProfile.topics[topicListIndex].selectedTopics = [];
            },
            enableOrDisableItems() {
                const noneId = this.speakerProfile.associations.find(x => x.associationName === 'None').id;
                const isNoneSelected = this.speakerProfile.selectedAssociationsList.some(x => x.id === noneId);
                if (isNoneSelected) {
                    this.speakerProfile.associations.forEach((item) => {
                        if (item.id !== noneId) {
                            item.disabled = true;
                        }
                        return item;
                    });
                } else {
                    this.speakerProfile.associations.forEach((item) => {
                        if (item.id !== noneId) {
                            item.disabled = false;
                        } else if (item.id === noneId && this.speakerProfile.selectedAssociationsList.length > 0) {
                            item.disabled = true;
                        } else if (item.id === noneId && this.speakerProfile.selectedAssociationsList.length === 0) {
                            item.disabled = false;
                        }
                        return item;
                    });
                }
            },
            removeCFFFee(fee) {
                const filteredFee = this.speakerProfile.cffFee.filter((x) => {
                    return x.trainingName !== fee.trainingName;
                });
                this.speakerProfile.cffFee = filteredFee;
            },
            onRegionChange(regionName) {
                const region = this.regionListForCFF.find(r => r.name === regionName);
                this.speakerProfile.cffRegion = {};
                this.speakerProfile.cffRegion.id = region.id;
                this.speakerProfile.cffRegion.name = region.name;
            },
            addNewTraining(tName, minFee, maxFee) {
                const newTraining = {
                    id: '',
                    trainingName: '',
                    maximumFee: '',
                    minimumFee: '',
                };
                if (tName && !this.trainingNames.includes(tName) && (minFee >= 0) && maxFee && maxFee > minFee) {
                    newTraining.id = this.generateGUID();
                    newTraining.trainingName = tName;
                    newTraining.maximumFee = maxFee;
                    newTraining.minimumFee = minFee;
                    this.speakerProfile.cffFee.push(newTraining);
                    this.feeError = false;
                } else {
                    this.feeError = true;
                }
                setTimeout(500, this.resetCffFee());
            },
            resetCffFee() {
                this.tName = '';
                this.minFee = '';
                this.maxFee = '';
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                countryList: `speaker/${storeGetters.countryList}`,
                feeRangeList: `speaker/${storeGetters.feeRangeList}`,
                speakerProfileFromState: `speaker/${storeGetters.speakerProfile}`,
                currentUserId: `auth/${storeGetters.currentUserId}`,
                isSpeakerView: `auth/${storeGetters.isSpeakerView}`,
                regionListForCFF: `speaker/${storeGetters.regionListForCFF}`,
                maxFeesRange: `speaker/${storeGetters.maxFeesRange}`,
                minFeesRange: `speaker/${storeGetters.minFeesRange}`,
            }),

            isMemberSpeaker() {
                return this.speakerProfileFromState && this.speakerProfileFromState.recordTypeName !== null && this.speakerProfileFromState.recordTypeName.toLowerCase() !== 'event speaker';
            },
            isEditBasicInfoValid() {
                return this.basicInfo_fieldsValid;
            },
            isEditDetailedInfoValid() {
                return this.detailed_fieldsValid && this.speakerProfile.topics.some(list => list.selectedTopics.length > 0) && !this.eventsYouHaveSpokeError && (!this.speakerProfile.isCFF || this.isCffInfoValid);
            },
            topicsError() {
                return this.isSpeakerDetailsValidated && !this.speakerProfile.topics.some(list => list.selectedTopics.length > 0);
            },
            eventsYouHaveSpokeError() {
                return this.speakerProfile.previuoslySpokenAtYpoEvent && this.speakerProfile.selectedSpeakerEventsYouHaveSpokes && this.speakerProfile.selectedSpeakerEventsYouHaveSpokes.length === 0;
            },
            presentationUploadAction() {
                return this.actions[storeAction.uploadSpeakerRegistrationPresentation];
            },
            loadingProfileAction() {
                return this.actions[storeAction.getSpeakerProfile];
            },
            loadingOptionsAction() {
                return this.actions[storeAction.getBasicOptionsForSpeaker];
            },
            basicMemberProfileSaveAction() {
                return this.actions[storeAction.saveEditedSpeakerProfile];
            },
            editedProfileSaveAction() {
                return this.actions[storeAction.saveEditedSpeakerProfile];
            },
            trainingNames() {
                return this.speakerProfile.cffFee.map(x => x.trainingName);
            },
            isCffInfoValid() {
                return this.speakerProfile && this.speakerProfile.cffFee && this.speakerProfile.cffFee.length > 0 && !this.qualificationError && !this.retreatTopicError;
            },
            qualificationError() {
                return this.speakerProfile && !this.speakerProfile.qualification;
            },
            retreatTopicError() {
                return this.speakerProfile && !this.speakerProfile.retreatTopic;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .edit-speaker-profile--wrapper {
        min-height: 500px;
    }

    .registration-page__my-topics__header__error {
        color: $ypo-error-red;
    }

    .edit-speaker-profile {
        padding: 10px 45px;
        margin-top: 65px;

        @include breakpoint(sm) {
            padding: 10px 15px;
        }

        &__unlock-member {
            background-color: $ypo-pink-background;
            color: $ypo-blue;
            width: 60%;
            margin: 45px auto 0;
            text-align: center;
            padding: 20px 30px;
            border-radius: 8px;

            @include breakpoint(md) {
                width: 95%;
            }

            @include breakpoint(xs) {
                width: 100%;
                margin: 60px auto 0;
                padding: 20px;
            }

            &--wrapper {
                height: 100%;
                z-index: 3;
                position: absolute;
                left: 0;
                right: 0;

                @include breakpoint(xs) {
                    margin: 0 20px;
                }
            }

            &-note {
                font-size: 30px;
                font-weight: 600;
                font-family: Raleway, serif;

                @include breakpoint(xs) {
                    font-size: 16px !important;
                }

                @include breakpoint(sm) {
                    font-size: 24px;
                }
            }

            &-note-2 {
                font-size: 14px;
                font-weight: 600;
                color: $ypo-cta;
                padding-left: 10px;

                @include breakpoint(xs) {
                    font-size: 12px !important;
                    padding: 20px 5px !important;

                    span {
                        display: block;
                    }
                }

                @include breakpoint(sm) {
                    font-size: 16px;
                }
            }

            &-edit-below {
                color: $ypo-blue;
                font-weight: 600;
                font-size: 14px;
                text-align: center;
                margin-top: 45px;

                @include breakpoint(xs) {
                    font-size: 12px;
                    margin-top: 100px;
                }

                @include breakpoint(sm) {
                    font-size: 16px;
                }
            }
        }

        .unlock-member-wrap {
            opacity: .1;
            width: 100%;
            height: 100%;
            z-index: 2;
        }

        &__cancel-btn {
            margin-bottom: 8px;

            .v-btn {
                margin-right: 0;

                .back-to {
                    font-size: 18px;
                    padding-right: 5px;
                }
            }
        }

        &__section {
            background-color: $ypo-tile-bgcolor;
            border: 1px solid $ypo-dark-background-gray;
            border-radius: 3px;
            position: relative;

            h3 {
                background-color: $ypo-blue;
                padding: 10px 20px;
                font-size: 18px;
                font-weight: 500;
                color: $white;
                text-transform: uppercase;
                border-radius: 3px 3px 0 0;
            }

            .unlock-edit {
                background-color: rgba($white, 0.9);
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                z-index: 1;
                align-items: center;
                justify-content: center;
                display: flex;

                &__popup {
                    text-align: center;
                    background-color: $ypo-pink-background;
                    max-width: 700px;
                    padding: 30px;
                    border-radius: 6px;

                    strong {
                        display: block;
                        color: $ypo-blue;
                        font-size: 32px;
                        font-weight: 600;
                        font-family: Raleway, serif;
                        line-height: 40px;
                    }

                    span {
                        color: $ypo-cta;
                        text-transform: uppercase;
                        font-size: 14px;
                        display: block;
                        font-weight: 600;
                        margin-top: 20px;
                    }

                    .v-btn {
                        margin-top: 20px;

                        .fa-pencil-alt {
                            padding-right: 10px;
                        }
                    }
                }
            }

            .note {
                background-color: $ypo-pink-background;
                font-size: 22px;
                color: $ypo-blue;
                text-align: center;
                margin: 0 0 20px 0;
                display: block;
                border-radius: 8px;
                padding: 10px 0;
                font-weight: 600;
                font-family: Raleway, serif;
            }

            form {
                padding: 20px;
                position: relative;

                .edit-member-profile {
                    position: relative;
                    padding-left: 280px;

                    .member {
                        width: 256px;
                        position: absolute;
                        left: 0;

                        figure {
                            position: relative;
                            background: rgba($ypo-gray, 0.18);
                            display: flex;
                            justify-content: center;
                            min-height: 250px;

                            .v-img {
                                max-width: 100%;
                                max-height: 100%;
                            }

                            small {
                                position: absolute;
                                background-color: $ypo-dark-green;
                                bottom: 0;
                                font-size: 12px;
                                font-weight: 600;
                                text-transform: uppercase;
                                color: $white;
                                left: 0;
                                width: 100%;
                                text-align: center;
                                padding: 5px;
                            }

                            span {
                                width: 55px;
                                height: 55px;
                                position: absolute;
                                background-color: $ypo-cta;
                                border: 7px solid $ypo-tile-border;
                                right: -20px;
                                bottom: -20px;
                                border-radius: 50%;
                                color: $white;
                                cursor: pointer;
                                font-size: 20px;
                                align-items: center;
                                display: flex;
                                justify-content: center;
                            }
                        }
                    }
                }

                .custom-fields {
                    &__sm7 {
                        max-width: 61.5%;
                        flex-basis: 61.5%;
                    }

                    &__sm5 {
                        max-width: 38.5%;
                        flex-basis: 38.5%;
                    }
                }

                .form-control {
                    padding: 0 10px;
                    margin-bottom: 8px;

                    label {
                        font-weight: 600;
                        color: $ypo-blue;
                        font-size: 14px;
                    }

                    .v-input__slot {
                        border: 1px solid $ypo-tile-border;
                    }

                    .more-info {
                        font-weight: 600;
                        font-size: 12px;
                        color: $ypo-cta;
                        display: block;
                        margin-top: 5px;
                    }

                    &__add-more {
                        display: block;
                        text-align: right;
                        margin-top: 5px;

                        small {
                            cursor: pointer;
                            font-size: 14px;
                            font-weight: 600;
                            color: $ypo-blue;
                        }
                    }

                    &__add-icon {
                        color: $ypo-blue;
                        font-size: 14px;
                        cursor: pointer;
                        white-space: nowrap;

                        small {
                            font-size: 14px;
                            font-family: Gentona, Arial, Helvetica, sans-serif;
                            font-weight: 600;
                            padding-left: 5px;
                        }
                    }

                    &__more-info {
                        color: $ypo-cta;
                        font-size: 12px;
                    }

                }

                .certified-forum {
                    background-color: $ypo-tile-border;
                    border: 1px solid $ypo-dark-background-gray;
                    border-radius: 8px;
                    padding: 10px;
                    margin-bottom: 30px;

                    &__title {
                        padding: 10px;
                        font-size: 18px;
                        color: $ypo-blue;

                        label {
                            margin-right: 5px;
                        }
                    }

                    &__daily-rate {
                        .delete-row {
                            position: relative;
                            padding-right: 14px;

                            &__delete {
                                position: absolute;
                                bottom: 15px;
                                right: 0;
                                color: $ypo-cta;
                                font-weight: 600;
                                font-size: 16px;
                                cursor: pointer;
                            }
                        }

                        .add-row {
                            padding-right: 14px;
                            border-top: 1px solid $ypo-dark-background-gray;
                            position: relative;

                            &__add {
                                position: absolute;
                                bottom: 33px;
                                right: 0;
                                color: $ypo-cta;
                                font-weight: 600;
                                font-size: 16px;
                                cursor: pointer;
                            }
                        }
                    }

                    .since-txt {
                        display: inline-block;
                    }
                }

                .facilitator-info {
                    background-color: $ypo-tile-border;
                    border: 1px solid $ypo-dark-background-gray;
                    border-radius: 8px;
                    margin-bottom: 30px;
                    padding: 20px 10px 0 10px;

                    &__fees-rate {
                        .delete-section {
                            position: absolute;
                            right: 10px;
                            bottom: 37px;
                            cursor: pointer;

                            i {
                                color: $ypo-cta;
                                font-size: 16px;
                            }
                        }

                        .training-name {
                            border-top: 1px solid $ypo-dark-background-gray;
                        }
                    }

                }

            }

            .action-btns {
                border-top: 1px solid $ypo-dark-background-gray;
                padding: 10px 0 0 0;
                margin: 0 11px;
            }

            .speaker-presentations {
                padding: 0 10px 20px 10px;

                .v-form {
                    padding: 10px 0;

                    .form-control {
                        padding: 0;
                    }
                }

                &__title {
                    color: $ypo-blue;
                    font-weight: 600;
                    font-size: 14px;
                }

                &__update {
                    background-color: rgba($ypo-gray, 0.1);
                    text-align: center;

                    span {
                        width: 100px;
                        height: 100px;
                        border: 5px solid $ypo-cta;
                        color: $ypo-cta;
                        display: flex;
                        border-radius: 50%;
                        margin: 0 auto;
                        align-items: center;
                        justify-content: center;
                        font-size: 30px;
                    }

                    strong {
                        color: $ypo-cta;
                        font-size: 16px;
                        margin-top: 4px;
                        display: block;
                    }

                    p {
                        padding: 0;
                        margin: 5px 0 0 0;
                        font-size: 16px;
                        line-height: normal;
                        color: $ypo-black-opac;
                    }

                    small {
                        display: block;
                        line-height: normal;
                        color: $ypo-blue;
                    }
                }

                &__video {
                    margin-top: 20px;
                }
            }

            .speaker-basic-info {
                &__sm7 {
                    max-width: 61.3%;
                    flex-basis: 61.3%;
                }

                &__sm5 {
                    max-width: 38.7%;
                    flex-basis: 38.7%;
                }
            }

            .blocked-layover {
                top: 0;
            }
        }

        &__all-error-text {
            color: $ypo-error-red;

            span {
                color: $ypo-error-red;
            }
        }

        // Only for Ipad Pro
        @media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
            margin-top: 110px;
        }

        // Only for Ipad mini
        @media only screen and (min-width: 768px) and (max-height: 1024px) and (-webkit-min-device-pixel-ratio: 1.5) {
            margin-top: 110px;
        }

        @include breakpoint(md) {
            &__section {
                .v-form {
                    .custom-fields {
                        &__sm7 {
                            max-width: 65.5%;
                            flex-basis: 65.5%;
                        }

                        &__sm5 {
                            max-width: 34.5%;
                            flex-basis: 34.5%;
                        }
                    }
                }

                .speaker-basic-info {
                    &__sm7 {
                        max-width: 66%;
                        flex-basis: 66%;
                    }

                    &__sm5 {
                        max-width: 34%;
                        flex-basis: 34%;
                    }
                }
            }
        }

        @include breakpoint(sm) {
            &__section {
                .speaker-presentations {
                    padding: 20px 10px;
                }

                .v-form {
                    .form-control {
                        &__add-icon {
                            white-space: nowrap;
                            font-size: 12px;

                            small {
                                font-size: 12px;
                            }
                        }
                    }

                    .edit-member-profile {
                        padding-left: 0;

                        .member {
                            position: relative;
                            margin: 0 auto;

                            figure {
                                margin-bottom: 40px;
                            }
                        }
                    }

                    .custom-fields {

                        &__sm7,
                        &__sm5 {
                            max-width: 50%;
                            flex-basis: 50%;
                        }
                    }
                }

                .speaker-basic-info {

                    &__sm7,
                    &__sm5 {
                        max-width: 100%;
                        flex-basis: 100%;
                    }
                }
            }
        }

        @include breakpoint(xs) {
            margin-bottom: 60px;
            padding: 10px;

            &__section {
                border: 0;
                border-radius: 0;

                h3 {
                    font-size: 12px;
                    border-radius: 0;
                }

                .v-form {
                    padding: 0;

                    .edit-member-profile {
                        .member {
                            width: 100%;

                            figure {
                                margin-bottom: 0;
                            }
                        }
                    }

                    .custom-fields {

                        &__sm7,
                        &__sm5 {
                            max-width: 100%;
                            flex-basis: 100%;
                        }
                    }
                }

                .note {
                    font-size: 13px;
                    text-align: left;
                    padding: 20px;
                    margin: 10px;
                    line-height: 22px;
                }

                .action-btns {
                    padding: 10px 0px 15px 0;
                }

                .speaker-basic-info {
                    .member {
                        margin-bottom: 20px !important;
                    }
                }

                .speaker-presentations {
                    &__title {
                        background-color: $ypo-blue;
                        padding: 10px 20px;
                        color: $white;
                        font-size: 12px;
                        text-transform: uppercase;
                    }
                }

                form {
                    .certified-forum {
                        &__title {
                            padding: 0;

                            span {
                                font-size: 16px;
                                font-weight: 600;
                            }
                        }

                        .since-txt {
                            display: inherit;
                        }

                        .form-control {
                            padding: 0 2px;
                        }

                        &__daily-rate {

                            .delete-row,
                            .add-row {
                                padding-right: 25px;
                            }
                        }
                    }
                }
            }
        }

    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .edit-speaker-profile {
        &__section {
            form {
                &__member {
                    width: 300px;

                    figure {
                        height: 200px;
                        position: relative;

                        .v-img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .form-control {
                    .v-input {
                        margin-top: 5px;
                        padding-top: 0;

                        .v-input__control {
                            min-height: 38px;

                            .v-input__slot {
                                border: 1px solid $ypo-tile-border;
                                border-radius: 3px;
                                transition: 0.3s all ease;
                                font-size: 14px;
                                background-color: $white;
                                margin-bottom: 0;

                                &:before {
                                    border: none;
                                }
                            }

                            .v-text-field__details {
                                padding-left: 0;
                            }
                        }

                        &.v-input--is-focused {
                            .v-input__slot {
                                border: 1px solid $ypo-blue;

                            }

                            &.error--text {
                                .v-input__slot {
                                    border: 1px solid $ypo-error-red;

                                }
                            }
                        }

                        .fa-link {
                            transform: rotate(45deg);
                            font-size: 18px;
                        }

                        .fa-times-circle {
                            font-size: 14px;
                            color: $ypo-blue;
                        }
                    }

                    .v-input--radio-group {
                        .v-input__control {
                            .v-input__slot {
                                border: none !important;
                                background-color: transparent !important;
                            }
                        }
                    }

                    &.select-radio {
                        .v-input__control {
                            .v-input__slot {
                                border: none !important;
                                background-color: $ypo-tile-bgcolor;

                                .v-label {
                                    font-size: 14px;
                                }
                            }
                        }
                    }

                    .v-chip {
                        background-color: $ypo-extra-light-gray;
                        border: 1px solid $ypo-cta;

                        .v-chip__content {
                            height: 28px;

                            i {
                                color: $ypo-cta !important;
                                opacity: inherit;
                            }
                        }
                    }

                    &.primary-phone {
                        .v-icon {
                            font-size: 18px;
                            font-weight: 600;
                        }
                    }
                }

                .open-caterogies {
                    padding: 0 10px;
                    margin-bottom: 30px;

                    label {
                        font-weight: 600;
                        color: $ypo-blue;
                        font-size: 14px;
                    }

                    .v-expansion-panel {
                        box-shadow: none;
                        margin: 10px 0;
                        border-left: 3px solid $white;

                        .v-expansion-panel__container {
                            background-color: transparent;
                            border: 0;

                            &:nth-child(odd) {

                                .v-expansion-panel__header,
                                .v-expansion-panel__body {
                                    background-color: $white;
                                }
                            }

                            .v-expansion-panel__header {
                                padding: 10px;
                                color: $ypo-cta;
                            }

                            .v-expansion-panel__header__icon {
                                display: none;
                            }

                            .v-expansion-panel__body {
                                padding: 15px;
                            }

                            &.v-expansion-panel__container--active {
                                .fa-plus-square {
                                    &:before {
                                        content: "\F146";
                                    }
                                }
                            }
                        }

                        .v-expansion-panel__body {
                            .v-chip {
                                background-color: $ypo-extra-light-gray;
                                border: 1px solid $ypo-cta;

                                .v-chip__content {
                                    height: 28px;

                                    i {
                                        color: $ypo-cta !important;
                                        opacity: inherit;
                                    }
                                }
                            }

                            .v-label {
                                font-size: 12px;
                                font-weight: 500;
                                color: $ypo-gray-text !important;
                            }

                            .v-input {
                                .v-icon {
                                    color: $ypo-cta;
                                    font-size: 18px;
                                }

                                .v-input__slot {
                                    margin-bottom: 0;

                                }
                            }

                            .clear-all {
                                display: inline-block;
                                color: $ypo-cta;
                                margin: 4px;
                                cursor: pointer;

                                &__close {
                                    color: $black;
                                    vertical-align: text-bottom;
                                    font-size: 18px;
                                    cursor: pointer;
                                }
                            }

                        }

                    }

                }

            }

            .status-success {
                z-index: 3;
            }
        }

        .video-uploader {
            position: relative;
            margin-top: 10px;
            min-height: 230px;

            #file-drag-drop {
                background-color: transparent;

                span {
                    i {
                        color: rgba($ypo-blue, 0.2);
                        font-size: 70px;
                    }
                }

                strong {
                    font-size: 14px;
                }

                small {
                    font-size: 12px;
                    font-weight: 500;
                    color: $ypo-blue;
                    display: block;
                    margin: 5px 0 0 0;
                }

                .drop-area {
                    border: 0 !important;
                    cursor: pointer;
                    margin: 0;
                    background-color: transparent;
                    align-items: center;
                    display: flex;
                    min-height: 230px;

                    .drop-files {
                        color: $ypo-cta;
                        font-size: 12px;
                        margin: 0;
                    }

                    .fa-cloud-upload-alt {
                        position: absolute;
                        bottom: 10px;
                        margin-left: 15px;
                        color: $ypo-cta !important;
                        font-size: 20px !important;
                    }

                }
            }
        }
    }

    .edit-member-profile {
        padding-left: 0;

        &__cropper {
            position: absolute !important;
            right: 0;
            bottom: -5px;

            i {
                font-size: 20px;
            }

            .fa-camera {
                border: 4px solid $ypo-open-blue-gray;
                position: absolute !important;
                top: inherit !important;
                height: 40px !important;
                width: 40px !important;
                bottom: 0px !important;

                &:before {
                    position: absolute;
                    top: 5px;
                    bottom: 0;
                    right: 0;
                    left: 0;
                }
            }
        }

        .member {
            figure {
                .v-responsive__sizer {
                    padding-bottom: 0 !important;
                }
            }
        }
    }
</style>
